export const iconFontAwesomeFilmVideoClapperboard = (
	<i className="fa-solid fa-clapperboard"></i>
);
